import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
    emp_list: {},
    emp_count: 0,
    permissions: [], // Added permissions array to store menu IDs
}

const empSlice = createSlice({
    name: "emp_personal",
    initialState: initial_state,
    reducers: {
        increment: (state) => {
            state.emp_count += 1;
        },
        decrement: (state) => {
            state.emp_count -= 1;
        },
        addtoCart: (state, action) => {
            console.log(action);
        },
        setUserData: (state, action) => {
            state.emp_list = action.payload;
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload; // Update permissions with new IDs
        }
    }
})

export const { increment, decrement, addtoCart, setUserData, setPermissions } = empSlice.actions;
export default empSlice.reducer;